import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class RiverSpring1TerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.RIVER_SPRING1;
}

export default RiverSpring1TerrainTileEntity;
